import React from 'react';

const DepartmentEventIcon = () => {
  return (
    <svg width='35' height='15' viewBox='0 0 35 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='35' height='15' rx='7.5' fill='#F76707' />
      <path
        d='M29.0869 7.77344V8.51562H22.9932V3.83789H28.999V4.58984H23.9307V5.77148H28.8135V6.50391H23.9307V7.77344H29.0869ZM29.9951 10V10.7617H21.9873V10H29.9951Z'
        fill='white'
      />
      <path
        d='M20.8057 3.11523V9.75586H19.9268V3.11523H20.8057ZM19.0967 3.27148V9.48242H18.2178V6.36719H17.1436V8.13477H13.7158V3.80859H14.5947V5.24414H16.2842V3.80859H17.1436V5.61523H18.2178V3.27148H19.0967ZM14.5947 7.38281H16.2842V5.95703H14.5947V7.38281ZM21.0596 10.9277V11.6797H15.0049V8.85742H15.9229V10.9277H21.0596Z'
        fill='white'
      />
      <path
        d='M11.9482 3.11523V11.8848H11.0205V3.11523H11.9482ZM7.27051 3.76953C8.56934 3.76953 9.52637 4.96094 9.52637 6.83594C9.52637 8.7207 8.56934 9.91211 7.27051 9.91211C5.95215 9.91211 5.00488 8.7207 5.00488 6.83594C5.00488 4.96094 5.95215 3.76953 7.27051 3.76953ZM7.27051 4.59961C6.45996 4.59961 5.90332 5.45898 5.90332 6.83594C5.90332 8.22266 6.45996 9.08203 7.27051 9.08203C8.07129 9.08203 8.62793 8.22266 8.62793 6.83594C8.62793 5.45898 8.07129 4.59961 7.27051 4.59961Z'
        fill='white'
      />
    </svg>
  );
};

export default DepartmentEventIcon;
